// 菲律宾语
export default {
	login: {
		salesBackend: "OMELINK Sales Backend Login",
		account: "Account",
		password: "Password",
		login: "Mag-login",
		pleaseEnter: "Mangyaring ilagay",
		userName: "Username",
		loginSuccessful: "Matagumpay na pag-login",
		usingOa: "Mag-log in gamit ang iyong OA account",
		usingSjfood: "Mag-log in gamit ang iyong HiFood account",
	},
	index: {
		customerSettings: "Mga Setting ng Customer",
		personalInformation: "Personal na Impormasyon",
		logOut: "Mag-log Out",
		selectLanguage: "Pumili ng Wika",
		confirmExit: "Kumpirmahang lalabas?",
		hint: "Paalala",
		productSettings: "Mga Setting ng Produkto",
		syncSettings: "Mga Setting ng Sync",
		customerBinding: "Pagbubuklod ng Customer",
	},
	personal: {
		avatar: "Avatar",
		nickName: "Palayaw",
	},
	operator: {
		addTo: "Idagdag sa",
		authorizer: "Tagapagbigay ng Pahintulot",
		permissions: "Mga Pahintulot",
		startingTime: "Oras ng Pagsisimula",
		endTime: "Oras ng Pagtatapos",
		revise: "Baguhin",
		delete: "Burahin",
		viewPermissions: "Tingnan ang Mga Pahintulot, Ipadala ang Mga Pahintulot",
	},
	customer: {
		customerCode: "Customer Code",
		customerName: "Pangalan ng Customer",
		warehouse: "Warehouse",
		customerBindingQuantity: "Dami ng Pagbubuklod ng Customer",
		maintenanceQuantity: "Dami ng Pagpapanatili ng Pagbabago ng Materyal",
		operate: "Operate",
		customerBinding: "Pagbubuklod ng Customer",
		productSettings: "Mga Setting ng Produkto",
		batchOpertion: "Batch na Pagpapanatili",
		selectCustomer: "Pumili ng Customer",
		importItem: "Mag-import ng Item",
		batchImportItem: "Batch na Pag-import ng Item",
		successfully: "Natapos",
		previousStep: "Nakaraang Hakbang",
		nextStep: "Susunod na Hakbang",
		selectFile: "Pumili ng File",
		templateDownload: "I-download ang Template",
		noFileSelected: "Walang file na napili",
		downloadingTemplate: "Matagumpay na na-download ang template",
		operationSuccess: "Matagumpay ang batch na pagpapanatili",
		aTotalOf: "Kabuuang",
		errorTips: "mga item na natukoy ng system na may ID error, nabigo ang pag-import! Pakisuri at subukan muli.",
		importSuccessfully: "Matagumpay ang pag-import",
	},
	customerProduct: {
		myClient: "Aking Kliyente",
		productSettings: "Mga Setting ng Produkto",
		specification: "Espesipikasyon",
		editedSuccessfully: "Matagumpay na nabago!",
	},
	customerProductLastest: {
		myClient: "Aking Kliyente",
		productSettings: "Mga Setting ng Produkto",
		syncSettings: "Mga Setting ng Sync",
		changeUpdates: "Suriin ang Mga Pagbabago sa Produkto",
		old: "Luma",
		new: "Bago",
		state: "Estado",
		waitingForConfirmation: "Naghihintay ng kumpirmasyon",
		applied: "Na-apply",
		notApplied: "Hindi na-apply",
		operate: "Operate",
		newAdditions: "Mga Bagong Dagdag",
		renew: "Pag-renew",
		time: "Oras",
		SALESConfirmed: "Kumpirmado ng SALES",
		application: "Application",
		notApplied: "Hindi na-apply",
		successfulOperation: "Matagumpay na operasyon!",
	},
	customerPhone: {
		myClient: "Aking Kliyente",
		customerBinding: "Pagbubuklod ng Customer",
		addBinding: "Magdagdag ng Pagbubuklod",
		noData: "Walang data, mangyaring magdagdag",
		telephoneNumber: "Numero ng Telepono",
		remarkName: "Pangalan ng Tala",
		memorandum: "Memorandum",
		smsDisable: "I-disable ang SMS",
		operate: "Operate",
		edit: "Pag-edita",
		unbind: "Tanggalin ang pagbubuklod",
		CRMContact: "Pumili ng CRM Contact",
		enterANote: "Maglagay ng tala",
		editBinding: "Pag-edita ang Pagbubuklod",
		correctPhoneNumber: "Mangyaring ilagay ang tamang format ng numero ng telepono",
		ContentIsTooLong: "Mangyaring ilagay ang memo",
		bindingSuccessfully: "Matagumpay na naidagdag ang pagbubuklod!",
		errorMessage: "May mga error sa impormasyong nilagay!",
		successfulOperation: "Matagumpay na operasyon!",
		setupSuccessful: "Matagumpay na nai-setup!",
		closedSuccessfully: "Matagumpay na nasara!",
		unbindHint: "Sigurado ka bang tatanggalin ang pagbubuklod?",
		hint: "Paalala",
		UnbindingSuccessful: "Matagumpay na natanggal ang pagbubuklod!",
		numberIdentityNote: "Numero, Pagkakakilanlan, Tala",
		selectIdentityNote: "Pumili ng Tala ng Pagkakakilanlan",
		customRemarks: "Pasadyang Tala ng Numero at Pagkakakilanlan",
		pleaseEnterCustomRemarks: "Mangyaring ilagay ang pasadyang tala ng numero at pagkakakilanlan",
		manager: "Manager",
		boss: "Boss",
		headChef: "Head Chef",
		accountant: "Accountant",
		custom: "Custom",
		phoneEditDelateGuid: "Hindi maaaring i-operate ang mga contact na nagmula sa CRM. Mangyaring gawin ang operasyon sa CRM.",
		billManagement: "Pagdagdag ng Mga Bill",
		add: "Magdagdag ng Mga Bill",
	},
	productSpecification: {
		addTo: "Idagdag sa",
		nameSearch: "Ilagay ang pangalan ng espesipikasyon para sa paghahanap",
		specificationName: "Pangalan ng Espesipikasyon",
		operate: "Operate",
		edit: "Pag-edita",
		editSpecifications: "Pag-edita ang Espesipikasyon",
		attributes: "Mga Katangian",
		addAttributes: "Mangyaring magdagdag ng mga katangian",
		name: "Pangalan",
		optionName: "Ilagay ang pangalan ng opsyon",
		enterSpecificationName: "Mangyaring ilagay ang pangalan ng espesipikasyon!",
		addOptions: "Mangyaring magdagdag ng mga opsyon!",
		editedSuccessfully: "Matagumpay na nabago!",
		errorMessage: "May mga error sa impormasyong nilagay!",
		enterAttributeName: "Ilagay ang pangalan ng katangian",
		sureDelete: "Sigurado ka bang buburahin?",
		hint: "Paalala",
		successfullyDeleted: "Matagumpay na nabura!",
		cannotSortWhenSearching: "Ei voi lajitella haun aikana",
		sortingSaveFail: "Lajittelu tallennus epäonnistui",
		sortingSaveSuccess: "Lajittelu tallennus onnistui",
	},
	productHistory: {
		materialChange: "Pagpapanatili ng Pagbabago ng Materyal",
		aliasSearch: "Ilagay ang pangalan ng produkto o alias para sa paghahanap",
		noData: "Walang data",
		productName: "Pangalan ng Produkto",
		productAlias: "Alias ng Produkto",
		category: "Kategorya",
		state: "Estado",
		enable: "Paganahin",
		disable: "I-disable",
		operate: "Operate",
		edit: "Pag-edita",
		codingImportGoods: "Mag-import ng mga produkto gamit ang customer code",
		importProducts: "Mag-import ng mga produkto",
		enterCustomerCode: "Ilagay ang customer code",
		selectProduct: "Pumili ng produkto",
		finish: "Tapusin",
		customerCode: "Customer Code",
		nextStep: "Susunod na hakbang",
		cancelSelection: "kanselahin ang pagpili",
		previous: "Nakaraan",
		import: "I-import",
		aTotalOf: "Ang kabuuang ",
		productImportSuccess: "mga produkto ay matagumpay na na-import",
		productImportFailure: "mga produkto ay natukoy ng system bilang mga doble at ang pag-import ay nabigo! Mangyaring suriin bago mag-import.",
		pleaseEnterCustomerCode: "Mangyaring ilagay ang customer code!",
		messageInformationCorrectly: "Mangyaring punan nang tama ang impormasyon!",
		pleaseSelectProduct: "Mangyaring piliin ang impormasyon ng produkto na gusto mong i-import!",
	},
	productEdit: {
		editProductInformation: "Pag-edita ang Impormasyon ng Produkto",
		basicInformation: "Pangunahing Impormasyon",
		productName: "Pangalan ng Produkto",
		productAlias: "Alias ng Produkto",
		category: "Kategorya",
		state: "Estado",
		enable: "Paganahin",
		disable: "I-disable",
		specificationInformation: "Impormasyon ng Espesipikasyon",
		selectSpecifications: "Pumili ng Mga Espesipikasyon",
		deleteSpecification: "Burahin ang Espesipikasyon",
		enterSpecificationName: "Ilagay ang pangalan ng espesipikasyon",
		addSpecs: "Magdagdag ng mga espesipikasyon",
		pleaseChoose: "Mangyaring pumili",
		attributes: "Mga Katangian",
	},
	productAll: {
		aliasSearch: "Ilagay ang pangalan ng produkto o alias para sa paghahanap",
		noData: "Walang data",
		productName: "Pangalan ng Produkto",
		productAlias: "Alias ng Produkto",
		category: "Kategorya",
		state: "Estado",
		enable: "Paganahin",
		disable: "I-disable",
		operate: "Operate",
		edit: "Pag-edita",
		insert: "Ipasok",
		insertingSuccessfully: "Matagumpay na naipasok ang kasaysayan!",
	},
	avatar: {
		setAvatar: "I-set ang Avatar",
		preview: "Preview",
		changePicture: "Palitan ang Larawan",
		enlarge: "Palakihin",
		zoomOut: "Paliliitin",
		rotateLeft: "I-rotate pakaliwa",
		rotateRight: "I-rotate pakanan",
		upload: "I-upload",
		errorGetAvatar: "Nabigong makuha ang avatar, mangyaring subukan muli mamaya",
		sizeCannotExceed: "Ang laki ng larawan ng avatar na i-upload ay hindi dapat lumampas sa 2MB!",
		selectPicture: "Pumili ng larawan",
		setupSuccessful: "Matagumpay na nai-setup",
		uploadFailed: "Nabigong i-upload, mangyaring subukan muli mamaya",
	},
	addSpecification: {
		addSpecs: "Magdagdag ng mga espesipikasyon",
		specificationName: "Pangalan ng Espesipikasyon",
		attributes: "Mga Katangian",
		addAttributes: "Mangyaring magdagdag ng mga katangian",
		addTo: "Idagdag sa",
		name: "Pangalan",
		operate: "Operate",
		delete: "Burahin",
		addProperties: "Magdagdag ng mga katangian",
		enterAttributeName: "Ilagay ang pangalan ng katangian",
		enterSpecificationName: "Ilagay ang pangalan ng espesipikasyon!",
		addOptions: "Magdagdag ng mga opsyon",
		addedSuccessfully: "Matagumpay na naidagdag!",
		errorMessage: "May mga error sa impormasyong nilagay!",
	},
	chatEmojiPicker: {
		recent: "Kamakailan",
		people: "Mga Tao",
		nature: "Kalikasan",
		foods: "Mga Pagkain",
		activity: "Aktibidad",
		places: "Mga Lugar",
		objects: "Mga Bagay",
		symbols: "Mga Simbolo",
		flags: "Mga Watawat",
	},
	chatHistoryMessage: {
		viewContext: "Tingnan ang Konteksto",
		copy: "Kopyahin",
		save: "I-save",
		copiedToClipboard: "Nakopya sa clipboard",
		copyFailed: "Nabigong kopyahin",
		errorTextMessage: "Pansamantalang sumusuporta lamang sa pagkopya ng text message",
		errorMessage: "Pansamantalang sumusuporta lamang sa pag-save ng voice message",
	},
	chatHistory: {
		enterChatContent: "Ilagay ang nilalaman ng chat",
		back: "Bumalik",
	},
	chatMessageCheckDetails: {
		serialNumber: "Serial Number",
		amount: "Halaga",
		uploadDate: "Petsa ng Pag-upload",
		frontPicture: "Harap na Larawan ng Tseke",
		reversePicture: "Likod na Larawan ng Tseke",
		supplier: "Supplier",
		userAmount: "Halagang Inilagay ng User",
		checkStatus: "Katayuan ng Tseke",
	},
	chatMessageCheck: {
		checkUploadReminder: "Paalala sa Pag-upload ng Tseke",
		checkCheckUpload: "Suriin ang Pag-upload ng Tseke",
		checkDetails: "Mga Detalye ng Tseke",
	},
	chatMessageNonsupport: {
		versionIsTooLow: "Ang iyong bersyon ay masyadong mababa upang matingnan ang nilalamang ito",
	},
	chatMessageOrder: {
		orderDetails: "Mga Detalye ng Order",
		order: "Order",
		deliveryDate: "Petsa ng paghahatid",
		productsOrdered: "Mga produktong inorder",
		productsInclude: "Kasama sa mga produkto",
		viewOrder: "Tingnan ang order",
	},
	chatMessageReadStatus: {
		haveRead: "Nabasa na",
		unread: "Hindi pa nababasa",
		readingStatus: "Katayuan ng Pagbabasa",
	},
	chatMessageStatus: {
		resendThisMessage: "Ipadala muli ang mensaheng ito?",
		hint: "Paalala",
	},
	chatMessageText: {
		translateText: "Isalin ang Teksto",
	},
	chatMessageVoice: {
		voiceIsCorrupted: "Nasira ang boses",
	},
	chatMessages: {
		retractedMessage: "Binawi mo ang isang mensahe",
		copy: "Kopyahin",
		save: "I-save",
		recall: "Bawiin",
		concealTranslated: "Itago ang Isinalin",
		translated: "Isinalin",
		copiedToClipboard: "Nakopya sa clipboard",
		copyFailed: "Nabigong kopyahin",
		supportsTextMessages: "Pansamantalang sumusuporta lamang sa pagkopya ng text message",
		supportsTextVoice: "Pansamantalang sumusuporta lamang sa pag-save ng voice message",
		supportsTexttranslated: "Pansamantalang sumusuporta lamang sa pagsasalin ng teksto",
	},
	chatPicturePaster: {
		sendThisImage: "Ipadala ang larawang ito?",
		send: "Ipadala",
	},
	chatRecorder: {
		recording: "Nagre-record",
		stop: "Itigil",
		send: "Ipadala",
		recordingFailed: "Nabigong mag-record",
		timeShort: "Masyadong maikli ang oras ng pagsasalita",
		timeLong: "Masyadong mahaba ang oras ng pagsasalita",
		microphonePermissionDenied: "Nabigo ang pag-record, mangyaring payagan ang access sa mikropono.",
	},
	contactList: {
		remarkName: "Pangalan ng Tala:",
	},
	contacts: {
		contactPerson: "Kontak",
	},
	conversationList: {
		recentChat: "Kamakailang Chat",
		remarkName: "Pangalan ng Tala:",
		cancelStick: "Kanselahin ang Pagdikit",
		haveRead: "Nabasa na",
		unread: "Hindi pa nababasa",
		stick: "Idikit",
		pinnedSuccessfully: "Matagumpay na naipin!",
		unpinnedSuccessfully: "Matagumpay na natanggal ang pin!",
	},
	detailContact: {
		chatInformation: "Impormasyon ng Chat",
		METISusageCount: "Bilang ng Paggamit ng METIS:",
		leftOver: "Natitira",
		strip: "Strip",
		nickName: "Palayaw",
		remarkName: "Pangalan ng Tala",
		revise: "Baguhin",
		associatedCustomers: "Mga Kaugnay na Customer",
		none: "Wala",
		smartResponse: "Serbisyo sa Customer na METIS Smart Response",
		open: "Buksan",
		close: "Isara",
		automaticTranslation: "Awtomatikong Pagsasalin",
		setupSuccessful: "Matagumpay na nai-setup!",
		enterRemarks: "Ilagay ang mga tala",
		hint: "Paalala",
		yes: "OO",
		no: "HINDI",
		phoneNumber: "Puhelinnumero",
		openTip1: "PST 13:30 - susunod na araw PST 01:00",
		openTip2: "Sa loob ng panahong ito, kung ang intensyon ng tanong ng customer ay kilala bilang isang kilalang isyu, sasagot nang normal ang METIS.",
		openTip3: "Sa loob ng panahong ito, kung ang intensyon ng tanong ng customer ay kilala bilang isang hindi kilalang isyu, hindi sasagot ang METIS.",
		userDoesNotBelong: "Ang kasalukuyang user ay hindi iyong contact",
	},
	detailGroup: {
		groupInformation: "Impormasyon ng Grupo",
		groupChatName: "Pangalan ng Pangkat Chat:",
		modifyGroupName: "Baguhin ang Pangalan ng Grupo",
		addMember: "Magdagdag ng Miyembro",
		noData: "Walang data, mangyaring magdagdag",
		avatar: "Avatar",
		nickName: "Palayaw",
		groupNotes: "Mga Tala ng Grupo",
		operate: "Operate",
		editorNotes: "Pag-edita ang Mga Tala",
		removeMember: "Alisin ang Miyembro",
		userDoesNotBelong: "Ang kasalukuyang user ay hindi kabilang sa grupong ito!",
		enterTheCommentName: "Ilagay ang pangalan ng tala ng miyembro",
		hint: "Paalala",
		selectMembers: "Pumili ng mga miyembro",
		pleaseEnterTheGroupChatName: "Mangyaring ilagay ang pangalan ng Pangkat Chat",
		groupNameHasNotChanged: "Hindi nagbago ang pangalan ng grupo!",
		groupNameCannotBeEmpty: "Hindi maaaring walang laman ang pangalan ng grupo!",
		confirmToRemoveMember: "Kumpirmahang aalisin ang miyembro?",
	},
	groupList: {
		groupChat: "Pangkat Chat",
		createGroupChat: "Gumawa ng Pangkat Chat",
		groupName: "Pangalan ng Grupo:",
	},
	selectMember: {
		selectMembers: "Pumili ng Mga Miyembro",
		chosen: "Napili:",
		contactPerson: "Kontak",
		salesperson: "Salesperson",
		groupChat: "'s Pangkat Chat",
		atLeast: "Kailangan ng hindi bababa sa 3 miyembro para sa Pangkat Chat",
	},
	chat: {
		realTimeServer: "Nabigo ang real-time server connection, kumokonekta...",
		enterSearchContent: "Ilagay ang nilalaman ng paghahanap",
		recentChat: "Kamakailang Chat",
		addressBook: "Contact",
		groupChat: "Pangkat Chat",
		chatRecord: "Rekord ng Chat",
		selectLanguage: "Pumili ng Wika",
		ctrlEnter: "Pindutin ang Ctrl + Enter para magpadala ng mensahe",
		commandEnter: "Pindutin ang Command + Enter para magpadala ng mensahe",
		enter: "Pindutin ang Enter para magpadala ng mensahe",
		translateContent: "Isalin ang Nilalaman",
		send: "Ipadala",
		imageUploadFailed: "Nabigong i-upload ang larawan, mangyaring subukan muli",
		onlyWithdrawMessages: "Maaari mo lamang bawiin ang iyong sariling mga mensahe",
		fileError: "Videotiedoston tietoja ei voi lukea!",
		loadFailed: "Lataus epäonnistui, yritä uudelleen napsauttamalla",
		loading: "Ladataan...",
		fileErrorTip:
			"Nabigong ipadala. Ang format ng file ay sumusuporta sa mga larawan o MP4, ang laki ng file ay hindi lalampas sa 300MB, at ang haba ng file ay hindi lalampas sa 30 minuto.",
		aFile: "file",
		errorTip: "Nabigo ang pag-upload ng file, hindi maipadala muli, mangyaring piliing muli ang file na i-upload.",
	},
	messageJS: {
		voice: "[Boses]",
		picture: "[Larawan]",
	},
	storeIndexJS: {
		have: "Mayroon",
		unreadMessages: "hindi pa nababasang mga mensahe",
		haveNewMessage: "Mayroon kang bagong mensahe",
	},
	apiJS: {
		loginHasExpired: "Ang login ay nag-expire na, gusto mo bang mag-log in muli?",
		hint: "Paalala",
		unknownMistake: "Hindi kilalang pagkakamali",
	},
	router: {
		login: "Mag-login",
		customerCommunication: "Komunikasyon sa Customer",
		setup: "Pag-setup",
		myClient: "Aking Kliyente",
		customerBinding: "Pagbubuklod ng Customer",
		productSettings: "Mga Setting ng Produkto",
		syncSettings: "Mga Setting ng Sync",
		personalInformation: "Personal na Impormasyon",
		authorizationSettings: "Mga Setting ng Awtorisasyon",
		messageSending: "Pagpapadala ng Mensahe",
		aiEmail: "AI EMAIL设置",
		openClawManagement: "Pamamahala ng Digital Employee",
		omelinkUserServiceMaintenance: "OMELINK User Service Maintenance",
	},
	dateJS: {
		today: "Ngayon",
	},
	common: {
		cancel: "Kanselahin",
		confirm: "Kumpirmahin",
		sure: "Sigurado",
		delete: "Burahin",
		options: "mga opsyon",
		option: "opsyon",
		history: "Kasaysayan",
		all: "Lahat",
		setup: "Pag-setup",
	},
	chatMessageOrderDetails: {
		supplier: "Tagapagtustos",
		orderBy: "Inorder ni",
		billTo: "Bayaran ni",
		shipTo: "Ipadala kay",
		deliveryDate: "Petsa ng paghahatid",
		comment: "Komento",
		ordered: "Inorder",
		include: "Isama",
		orderDetails: "Mga detalye ng order",
	},
	generalization: {
		listTitle: "Markkinointilista",
		searchPlaceholder: "Hae",
		checkOut: "Tarkastele",
		sendAgain: "Lähetä uudelleen",
		send: "Lähetä heti",
		detailTitle: "Markkinointitiedot",
		isSendMessage: "Lähettää viestin",
	},
	messageSending: {
		title: "Mga customer na hindi nakarehistro sa OMELINK",
		customerName: "Pangalan ng bisita",
		customerPhone: "Telepono ng bisita",
		associatedRestaurantId: "ID ng kaugnay na restawran",
		restaurantName: "Pangalan ng restawran",
		operate: "Operasyon",
		historyRecord: "Talaan ng kasaysayan",
		sendMessage: "Ipadala ang SMS",
		cancel: "Kanselahin",
		confirm: "Kumpirmahin ang pagpapadala",
		restaurantId: "ID ng restawran",
		close: "Isara",
		orderId: "ID ng order",
		snedText: "Nilalaman na ipinadala",
		sendTime: "Oras ng pagpapadala",
		sendSuccess: "Matagumpay na ipinadala",
		isCheckedDocument: "Tingnan ang dokumento?",
		isDownLoad: "I-download ang OMELINK?",
		sendDocument: "Ipadala ang dokumento",
		true: "Oo",
		false: "Hindi",
		check: "Tingnan",
	},
	aiEmail: {
		account: "Email Account",
		accountDescription: "I-configure ang mailbox na gagamitin sa pagtanggap at pagproseso ng AI order emails.",
		configureAccount: "I-configure ang Email",
		editAccount: "I-edit ang Email",
		emailAddress: "Email Address",
		emailPassword: "Email Password",
		passwordSetHint: "Naka-configure na ang password. Iwanang blangko upang hindi ito mabago.",
		accountEnabled: "Paganahin ang pagproseso ng email",
		enabled: "Pinagana",
		disabled: "Hindi pinagana",
		syncError: "Error sa pag-sync",
		latestSync: "Huling pag-sync",
		noSyncTime: "Wala pa",
		accountEmpty: "Wala pang naka-configure na email account. Mag-save ng email address at password upang magsimula.",
		emailDisabledNotice: "Naka-disable ang email account na ito. Hindi isi-sync o ipoproseso ang emails, ngunit maaari pa ring pamahalaan ang mga contact.",
		contacts: "Mga Email Contact",
		contactsDescription: "Tanging ang order emails mula sa mga naka-configure na contact ang ipoproseso ng AI.",
		addContact: "Magdagdag ng Contact",
		editContact: "I-edit ang Contact",
		guestEmail: "Email ng Customer",
		processingMode: "Mode ng Pagproseso",
		automatic: "Ganap na Awtomatiko",
		semiAutomatic: "Semi-awtomatiko",
		automaticDescription: "Sasagot ang AI sa customer sa English at maglalagay ng order kapag kumpleto ang impormasyon.",
		semiAutomaticDescription: "Tahimik na kikilalanin ng AI ang intensyon ng order at maglalagay ng order nang hindi sumasagot sa customer.",
		associatedCustomers: "Kaugnay na Customers",
		updatedAt: "Na-update noong",
		actions: "Mga Aksyon",
		edit: "I-edit",
		delete: "Burahin",
		customerPlaceholder: "Pumili ng Customers",
		noCustomers: "Walang available na Customer para sa kasalukuyang salesperson.",
		loadingAccount: "Nilo-load ang email settings...",
		loadingContacts: "Nilo-load ang mga contact...",
		validatingConnection: "Sinusuri ang email connection...",
		save: "I-save",
		accountSaveSuccess: "Na-save ang email settings.",
		statusUpdateSuccess: "Na-update ang email status.",
		contactCreateSuccess: "Nagawa ang contact.",
		contactUpdateSuccess: "Na-update ang contact.",
		contactDeleteSuccess: "Nabura ang contact.",
		validationEmail: "Maglagay ng wastong email address.",
		validationPassword: "Kinakailangan ang email password sa unang pag-save ng account.",
		validationMode: "Pumili ng mode ng pagproseso.",
		validationCustomers: "Pumili ng hindi bababa sa isang Customer.",
		confirmDelete: "Kumpirmahin ang Pagbura",
		deleteContactMessage: "Pagkatapos burahin, hindi na magpoproseso ang system ng mga bagong email mula sa {email}. Burahin ang contact na ito?",
	},
	serviceMaintenance: {
		userList: "Listahan ng Mga User",
		serviceProviderList: "Listahan ng Mga Service Provider",
		customerName: "Pangalan ng Bisita",
		customerPhone: "Numero ng Telepono ng Bisita",
		associatedRestaurantId: "ID ng Kaugnay na Restawran",
		restaurantName: "Pangalan ng Restawran",
		operate: "Mga Aksyon / Operasyon",
		serviceMaintenance: "Pangangalaga sa Service Provider",
		batchMaintenance: "Maramihang Pangangalaga sa Service Provider",
		sort: "Bilang ng Pagkakasunud-sunod",
		applicationName: "Pangalan ng Aplikasyon",
		type: "Kategorya / Uri",
		status: "Katayuan (Status)",
		selectUsers: "Pumili ng Mga User",
		selectServiceProvider: "Pumili ng Service Provider(s)",
		complete: "Tapos na",
		nextStep: "Susunod na Hakbang",
		previous: "Nakaraang Hakbang",
		selectServiceProviderTip: "Piliin ang service provider(s) na ipapakita (ang hindi napili ay itatakda bilang nakatago/naka-block)",
		batchMaintenanceComplete: "Kumpleto na ang Maramihang Pangangalaga",
		latestShelvesTime: "Pinakabagong Oras ng Paglalagay sa Istante ",
		introduction: "Pagpapakilala sa Negosyo",
		businessName: "Pangalan ng Negosyo",
		show: "I-display",
		hide: "I-block",
		soft: "Software",
		service: "Serbisyo",
		successfulOperation: "Matagumpay na operasyon!",
	},
	openClawManagement: {
		guestName: "Pangalan ng Bisita",
		guestPhoneNumber: "Telepono ng Bisita",
		associatedRestaurantId: "ID ng Kaugnay na Restawran",
		restaurantName: "Pangalan ng Restawran",
		status: "Status ng Digital Employee",
		operate: "Operasyon",
		show: "I-display",
		hide: "I-block",
		noData: "Walang data",
		loading: "Ladataan...",
		updateSuccess: "Matagumpay na operasyon!",
	},
};
